import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'notification-dialog',
    templateUrl: './notification-dialog.component.html',
    standalone: false
})
export class NotificationDialogComponent {
  title: string;
  message: string;

  constructor(public dialogRef: MatDialogRef<NotificationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: NotificationDialogModel) {
    this.title = data.title;
    this.message = data.message;
  }

  onConfirm(): void {
    this.dialogRef.close(false);
  }
}

export class NotificationDialogModel {

  constructor(public title: string, public message: string) {
  }
}
